import React from 'react';
import Icon from './Icon';


function IconFilter(props) {
  return (<>
    <Icon width="22" height="18" style={props?.style} className={props?.className}>
      <path d="M13.3121 3.04492H1.00781" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M17.125 3.04492H20.8605" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M16.5621 4.39376C17.3071 3.64882 17.3071 2.44103 16.5621 1.69609C15.8172 0.951148 14.6094 0.951148 13.8645 1.69609C13.1195 2.44103 13.1195 3.64882 13.8645 4.39376C14.6094 5.1387 15.8172 5.1387 16.5621 4.39376Z" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M1.00781 14.9551H10.9778" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M20.8589 14.9551H14.7891" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M14.234 16.3039C14.9789 15.559 14.9789 14.3512 14.234 13.6062C13.4891 12.8613 12.2813 12.8613 11.5363 13.6062C10.7914 14.3512 10.7914 15.559 11.5363 16.3039C12.2813 17.0489 13.4891 17.0489 14.234 16.3039Z" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M4.7433 8.79492H1.00781" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M20.8576 8.79492H8.55469" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
      <path d="M8.41091 9.52527C8.81406 8.55196 8.35186 7.43611 7.37855 7.03295C6.40524 6.62979 5.28939 7.09199 4.88623 8.0653C4.48307 9.03861 4.94527 10.1545 5.91859 10.5576C6.8919 10.9608 8.00775 10.4986 8.41091 9.52527Z" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round"/>
    </Icon>
  </>);
};

export default IconFilter;
